import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { People } from '~/services/Http';

import { getMomentOfAnniversary } from '../../services';

import { useSxStyles } from './useStyles';

export interface Props {
  listItem: People.AnniversaryDto;
}

export const DialogAnniversary: React.FC<Props> = ({ listItem }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const daysLeft = getMomentOfAnniversary(listItem.date, t);
  const daysUntil = moment(listItem.date)
    .startOf('day')
    .diff(moment().startOf('day'), 'days');
  const upcomingYears = listItem.years + 1;
  const anniversaryType =
    listItem.type === People.AnniversaryTypeEnum.BIRTHDAY
      ? t('birthday')
      : t('anniversary');

  const anniversaryMessage = `${t('anniversaryInDaysSubtitle', {
    type: anniversaryType,
    days: daysUntil,
  })} (${t('onXDate', { dateFormatted: moment(listItem.date).format('L') })})`;
  console.log(anniversaryMessage, anniversaryType, daysLeft);

  return (
    <SummaryItem
      avatarProps={{
        alt: listItem.employee.firstName,
        src: listItem.employee.profilePic,
      }}
      badgeProps={{
        badgeContent: listItem.years,
        children: undefined,
        color:
          listItem.type !== People.AnniversaryTypeEnum.BIRTHDAY
            ? 'primary'
            : 'secondary',
      }}
      customSxStyles={{ listItemRoot: sxStyles.summaryItemListItemRoot }}
      href={`/page-ui2-redirect?empId=${listItem.employee.id}&area=people`}
      listItemProps={{ disableGutters: true }}
      primaryElement={`${listItem.employee.firstName} ${listItem.employee.lastName} ${upcomingYears}`}
      secondaryElement={anniversaryMessage}
    />
  );
};
